/**
 * GestureFloat必须放置到视图的根节点
 */
import React from 'react';
import { requireNativeComponent, View, Dimensions, UIManager, findNodeHandle, StyleSheet, PixelRatio } from 'react-native';
import { DeviceInfo } from 'qunar-react-native';
import { verUtil } from '@qnpm/q-design-utils';
export class GestureFloat extends React.Component {
    constructor(props) {
        super(props);
        //Tab模式所需内部属性，仅用于ios
        this.tabIsHasInit = false;
        this.tabIsHasLayout = false;
        this.tabContentIndexPoints = [];
        this.tabContentPoints = [];
        this.tabClickMoving = false;
        this.tabCurrentIndex = 0;
        this.tabPageNumber = 0;
        this.tabContentOffsetY = 0;
        /**
         * 在native侧滚动ScrollView的回调
         */
        this.onScrollHandler = (event) => {
            if (DeviceInfo.isIOS) {
                let eventData = event.nativeEvent;
                if (this.props.isTabHeader) {
                    this.tabPageNumber = eventData.pageNumber;
                    this.tabContentOffsetY = eventData.y;
                    this.resetTabIndex();
                }
                this.props.onScroll &&
                    this.props.onScroll(eventData.pageNumber, eventData.y);
            }
            else {
                let eventData = event.nativeEvent;
                let pageNumber;
                let scrollY;
                let datObj = JSON.parse(eventData.data);
                pageNumber = datObj.pageNumber;
                //将px转为dp
                scrollY = datObj.scrollY / PixelRatio.get();
                this.props.onScroll && this.props.onScroll(pageNumber, scrollY);
            }
        };
        /**
         * 在native侧，ScrollTo动画执行完后的回调
         */
        this.onScrollToFinishHandler = () => {
            if (DeviceInfo.isIOS) {
                if (this.props.isTabHeader) {
                    this.tabClickMoving = false;
                }
            }
        };
        /**
         * 在native侧触发hide动画开始时回调
         */
        this.onCloseHandler = (event) => {
            let eventData = event.nativeEvent;
            let index;
            let hideType = -1;
            if (DeviceInfo.isIOS) {
                index = eventData.index;
                hideType = eventData.type;
            }
            else {
                let datObj = JSON.parse(eventData.data);
                index = datObj.closingPageNumber;
                hideType = datObj.hideType;
            }
            this.props.onClose && this.props.onClose(index, hideType);
        };
        /**
         * 所有情况触发的hide动画执行结束
         */
        this.onCloseAnimateFinishHandler = (event) => {
            let eventData = event.nativeEvent;
            let index;
            if (DeviceInfo.isIOS) {
                index = eventData.index;
            }
            else {
                let datObj = JSON.parse(eventData.data);
                index = datObj.closedPageNumber;
            }
            this.props.onCloseAnimateFinish &&
                this.props.onCloseAnimateFinish(index);
        };
        /**
         * 页面状态发生改变
         */
        this.onStateChangeHandler = (event) => {
            let eventData = event.nativeEvent;
            let pageNumber;
            let state;
            if (DeviceInfo.isIOS) {
                pageNumber = eventData.pageNumber;
                state = eventData.state;
            }
            else {
                let datObj = JSON.parse(eventData.data);
                pageNumber = datObj.pageNumber;
                state = datObj.state;
            }
            this.props.onStateChange && this.props.onStateChange(pageNumber, state);
        };
        this.onTouchMoveChangeHandler = (event) => {
            let eventData = event.nativeEvent;
            let pageNumber;
            let isTouchMoving;
            if (DeviceInfo.isIOS) {
                pageNumber = eventData.pageNumber;
                isTouchMoving = eventData.isTouchMoving;
            }
            else {
                let datObj = JSON.parse(eventData.data);
                pageNumber = datObj.pageNumber;
                isTouchMoving = datObj.isTouchMoving;
            }
            this.props.onTouchMoveChange &&
                this.props.onTouchMoveChange(pageNumber, isTouchMoving);
        };
        this.onTabSelectedChange = (event) => {
            let eventData = event.nativeEvent;
            let pageNumber;
            let tabIndex;
            if (DeviceInfo.isIOS) {
                //ios不支持此方法
            }
            else {
                let datObj = JSON.parse(eventData.data);
                pageNumber = datObj.pageNumber;
                tabIndex = datObj.tabIndex;
            }
            this.props.onTabSelectedChange &&
                this.props.onTabSelectedChange(pageNumber, tabIndex);
        };
        this.onFixItemTouch = (event) => {
            let eventData = event.nativeEvent;
            if (DeviceInfo.isAndroid) {
                let datObj = JSON.parse(eventData.data);
                let pageNumber = datObj.pageNumber;
                let fixItemIndex = datObj.fixItemIndex;
                let touchX = datObj.touchX;
                let touchY = datObj.touchY;
                this.props.onFixItemTouch &&
                    this.props.onFixItemTouch(pageNumber, fixItemIndex, touchX, touchY);
            }
        };
        this.onFixItemTouchChange = (event) => {
            let eventData = event.nativeEvent;
            if (DeviceInfo.isAndroid) {
                let datObj = JSON.parse(eventData.data);
                let pageNumber = datObj.pageNumber;
                let isFixItemTouching = datObj.isFixItemTouching;
                this.props.onFixItemTouchChange &&
                    this.props.onFixItemTouchChange(pageNumber, isFixItemTouching);
            }
        };
        if (DeviceInfo.isIOS) {
            const { initTabIndex = 0 } = this.props;
            this.tabCurrentIndex = initTabIndex;
        }
        this.onTabContentSubViewLayout = this.onTabContentSubViewLayout.bind(this);
    }
    render() {
        //为6月底版本及以上才支持手势浮层
        const supportGestureFloat = verUtil.overVer.overV2;
        if (!supportGestureFloat) {
            // eslint-disable-next-line no-console
            console.warn('此native版本不支持GestureFloat：' + DeviceInfo.qrn_version);
            return null;
        }
        const QGestureFloatNative = requireNativeComponent('QDGestureFloat');
        if (!QGestureFloatNative) {
            return null;
        }
        const { isTabHeader, initTabIndex, pageNumber, borderTopRadius, showDuration, hideDuration, stopDuration, showDurationDetail, hideDurationDetail, stopDurationDetail, stopPercent, moveSensitivity, forbidSwipeBack, recoverSwipeBack, contentBgColor, showHeaderTip, scrollEnabled, forbidFullScreen, fixedIndexes, decelerationRate, hideGuideToast, scrollRate, initScrollY } = this.props;
        //隐藏浮层
        if (pageNumber === -2) {
            return null;
        }
        const viewList = DeviceInfo.isIOS
            ? this.buildViewListIos()
            : this.buildViewListAdr();
        if (!viewList) {
            return null;
        }
        return (<QGestureFloatNative style={styles.root} 
        // @ts-ignore
        ref={(qGestureFloatNative) => {
            this.qGestureFloatNativeRef = qGestureFloatNative;
        }} contentBgColor={contentBgColor} showHeaderTip={showHeaderTip} scrollEnabled={scrollEnabled} pageNumber={pageNumber} borderTopRadius={borderTopRadius} showDuration={showDuration} hideDuration={hideDuration} stopDuration={stopDuration} showDurationDetail={showDurationDetail} hideDurationDetail={hideDurationDetail} stopDurationDetail={stopDurationDetail} stopPercent={stopPercent} moveSensitivity={moveSensitivity} forbidSwipeBack={forbidSwipeBack} recoverSwipeBack={recoverSwipeBack} isTabHeader={isTabHeader} initTabIndex={DeviceInfo.isAndroid ? initTabIndex : undefined} forbidFullScreen={forbidFullScreen} fixedIndexes={fixedIndexes} decelerationRate={decelerationRate} hideGuideToast={hideGuideToast} scrollRate={scrollRate} initScrollY={initScrollY} onScroll={this.onScrollHandler} onScrollToFinish={this.onScrollToFinishHandler} onClose={this.onCloseHandler} onCloseAnimateFinish={this.onCloseAnimateFinishHandler} onStateChange={this.onStateChangeHandler} onTouchMoveChange={this.onTouchMoveChangeHandler} onTabSelectedChange={this.onTabSelectedChange} onFixItemTouch={this.onFixItemTouch} onFixItemTouchChange={this.onFixItemTouchChange}>
                {viewList.map((item) => item)}
            </QGestureFloatNative>);
    }
    componentDidMount() { }
    buildViewListAdr() {
        const { pageViewList = [] } = this.props;
        if (!pageViewList || pageViewList.length === 0) {
            return [];
        }
        const viewList = pageViewList.map((item, index) => {
            return (<View onLayout={() => { }} key={index}>
                    <View onLayout={() => { }} key={index} style={styles.container}>
                        {item.fixedHeader ? (<item.fixedHeader data={item.fixedHeaderData}/>) : null}
                    </View>
                    <View onLayout={() => { }} key={index} style={styles.container}>
                        <View onLayout={() => { }}>
                            {item.header ? (<item.header data={item.headerData}/>) : null}
                        </View>
                        <View onLayout={() => { }}>
                            {item.content ? (<item.content data={item.contentData}/>) : item.tabContents ? (item.tabContents.map((ContentView, order) => {
                return (<View onLayout={() => { }} key={order}>
                                            <ContentView data={item.tabContentsData &&
                    item.tabContentsData[order]}/>
                                        </View>);
            })) : null}
                        </View>
                    </View>

                    {item.footer ? (<View onLayout={() => { }} style={styles.container}>
                            <item.footer data={item.footerData}/>
                        </View>) : null}
                </View>);
        });
        return viewList;
    }
    buildViewListIos() {
        const { pageViewList = [], forbidFullScreen } = this.props;
        if (!pageViewList || pageViewList.length === 0) {
            return [];
        }
        const QGestureFloatPage = forbidFullScreen
            ? requireNativeComponent('QDGestureFloatHalfPage')
            : requireNativeComponent('QDGestureFloatPage');
        const QGestureFloatView = requireNativeComponent('QDGestureFloatView');
        const viewList = pageViewList.map((item, index) => {
            return (<QGestureFloatPage 
            // @ts-ignore
            style={styles.container} key={index}>
                    
                    {!forbidFullScreen ? (<QGestureFloatView>
                            {item.fixedHeader ? (<item.fixedHeader data={item.fixedHeaderData}/>) : null}
                        </QGestureFloatView>) : null}

                    
                    <QGestureFloatView>
                        {item.header ? (<item.header data={item.headerData}/>) : null}
                    </QGestureFloatView>

                    
                    <QGestureFloatView>
                        {item.content ? (<item.content data={item.contentData}/>) : item.tabContents ? (<View>
                                {item.tabContents.map((ContentView, order) => {
                return (<View onLayout={(e) => {
                    this.onTabContentSubViewLayout(e, order, item.tabContents.length);
                }} key={order}>
                                            <ContentView data={item.tabContentsData &&
                    item.tabContentsData[order]}/>
                                        </View>);
            })}
                            </View>) : null}
                    </QGestureFloatView>

                    
                    {item.footer ? (<QGestureFloatView>
                            <item.footer data={item.footerData}/>
                        </QGestureFloatView>) : null}
                </QGestureFloatPage>);
        });
        return viewList;
    }
    topPageScrollTo(y, animated) {
        if (DeviceInfo.isAndroid) {
            // @ts-ignore
            let getViewManagerConfig = UIManager.getViewManagerConfig;
            // @ts-ignore
            UIManager.dispatchViewManagerCommand(
            // @ts-ignore
            findNodeHandle(this.qGestureFloatNativeRef), getViewManagerConfig('QDGestureFloat').Commands.scrollTo, [0, y || 0, animated !== false]);
        }
        else {
            let param = animated
                ? { y: y, animated: true, duration: 200 }
                : { y: y, animated: false };
            // @ts-ignore
            let getViewManagerConfig = UIManager.getViewManagerConfig;
            // @ts-ignore
            UIManager.dispatchViewManagerCommand(
            // @ts-ignore
            findNodeHandle(this.qGestureFloatNativeRef), getViewManagerConfig('QDGestureFloat').Commands.scrollTo, [param]);
        }
    }
    topPageScrollToEnd(animated) {
        // @ts-ignore
        let getViewManagerConfig = UIManager.getViewManagerConfig;
        // @ts-ignore
        UIManager.dispatchViewManagerCommand(
        // @ts-ignore
        findNodeHandle(this.qGestureFloatNativeRef), getViewManagerConfig('QDGestureFloat').Commands.scrollToEnd, [animated !== false]);
    }
    closeFolatUseNativeProps() {
        this.qGestureFloatNativeRef &&
            this.qGestureFloatNativeRef.setNativeProps({ pageNumber: -1 });
    }
    resetPageLayout(isResetHeaderHeight) {
        if (DeviceInfo.isAndroid) {
            // @ts-ignore
            let getViewManagerConfig = UIManager.getViewManagerConfig;
            // @ts-ignore
            UIManager.dispatchViewManagerCommand(
            // @ts-ignore
            findNodeHandle(this.qGestureFloatNativeRef), getViewManagerConfig('QDGestureFloat').Commands.resetPageLayout, [isResetHeaderHeight !== false]);
        }
        else {
            // eslint-disable-next-line no-console
            console.log('ios', '不支持resetPageLayout');
        }
    }
    // 设置是否能滚动
    setScrollable(scrollable) {
        if (DeviceInfo.isAndroid) {
            // @ts-ignore
            let getViewManagerConfig = UIManager.getViewManagerConfig;
            // @ts-ignore
            UIManager.dispatchViewManagerCommand(
            // @ts-ignore
            findNodeHandle(this.qGestureFloatNativeRef), getViewManagerConfig('QDGestureFloat').Commands.setScrollable, [scrollable]);
        }
    }
    // 设置是否能滚动
    setSlidingBoundaryAngle(angle) {
        if (DeviceInfo.isAndroid) {
            // @ts-ignore
            let getViewManagerConfig = UIManager.getViewManagerConfig;
            // @ts-ignore
            UIManager.dispatchViewManagerCommand(
            // @ts-ignore
            findNodeHandle(this.qGestureFloatNativeRef), getViewManagerConfig('GestureFloat').Commands
                .setSlidingBoundaryAngle, [angle]);
        }
    }
    topPageScrollByTab(index, animated) {
        if (DeviceInfo.isAndroid) {
            // @ts-ignore
            let getViewManagerConfig = UIManager.getViewManagerConfig;
            // @ts-ignore
            UIManager.dispatchViewManagerCommand(
            // @ts-ignore
            findNodeHandle(this.qGestureFloatNativeRef), getViewManagerConfig('QDGestureFloat').Commands.scrollByTab, [index || 0, animated !== false]);
        }
        else {
            if (this.tabIsHasLayout && this.tabCurrentIndex !== index) {
                const movetoY = this.tabContentPoints[index].y;
                //点击tab后，滚动到指定位置
                if (this.qGestureFloatNativeRef) {
                    this.tabClickMoving = true;
                    // @ts-ignore
                    let getViewManagerConfig = UIManager.getViewManagerConfig;
                    // @ts-ignore
                    UIManager.dispatchViewManagerCommand(findNodeHandle(this.qGestureFloatNativeRef), getViewManagerConfig('QDGestureFloat').Commands
                        .scrollTo, [{ y: movetoY, animated: true, duration: 200 }]);
                }
                //点击Tab
                this.tabCurrentIndex = index;
            }
        }
    }
    //iOS：子tab内容布局完成后，记录坐标点
    onTabContentSubViewLayout(e, index, tabCount) {
        this.tabContentIndexPoints[index] = e.nativeEvent.layout.height;
        if (this.tabContentIndexPoints.filter((item) => item).length ===
            tabCount) {
            //所有组件都onLayout之后计算锚点,即计算组件相对滚动父元素的y值
            this.tabIsHasLayout = true;
            let p = [];
            this.tabContentIndexPoints.forEach((h, index) => {
                if (index === this.tabContentIndexPoints.length - 1) {
                    //最后一个不循环
                    p.unshift({
                        y: 0
                    });
                    return;
                }
                let result = {};
                if (index === 0) {
                    result.y = h;
                }
                else if (index !== this.tabContentPoints.length - 1) {
                    //最后一个元素的y值在index-1的时候就已经一算出来了
                    result.y = h + p[index - 1].y;
                }
                p.push(result);
            });
            this.tabContentPoints = p;
            //打开弹层后，计算完成之后移动到初始位置
            if (!this.tabIsHasInit) {
                this.tabIsHasInit = true;
                const movetoY = this.tabContentPoints[this.tabCurrentIndex].y;
                if (this.qGestureFloatNativeRef) {
                    // @ts-ignore
                    let getViewManagerConfig = UIManager.getViewManagerConfig;
                    // @ts-ignore
                    UIManager.dispatchViewManagerCommand(findNodeHandle(this.qGestureFloatNativeRef), getViewManagerConfig('QDGestureFloat').Commands
                        .scrollTo, [{ y: movetoY, animated: false, duration: 200 }]);
                }
            }
            else {
                //内容区高度发生改变，需重新计算
                this.resetTabIndex();
            }
        }
    }
    //iOS：UIScrollView滚动 或 内容区高度变化之后，重新计算
    resetTabIndex() {
        if (this.props.isTabHeader) {
            if (this.tabClickMoving) {
                return;
            }
            //滚动回调
            let movetoTabIndex = this.tabCurrentIndex;
            for (let i = 0; i < this.tabContentPoints.length; i++) {
                let p = this.tabContentPoints[i];
                if (this.tabContentOffsetY > p.y - 0) {
                    movetoTabIndex = i;
                }
            }
            if (movetoTabIndex !== this.tabCurrentIndex) {
                this.tabCurrentIndex = movetoTabIndex;
                this.props.onTabSelectedChange &&
                    this.props.onTabSelectedChange(this.tabPageNumber, movetoTabIndex);
            }
        }
    }
}
const styles = StyleSheet.create({
    root: {
        position: 'absolute',
        bottom: 0,
        top: 0,
        left: 0,
        right: 0
    },
    container: {
        position: 'absolute',
        top: 0,
        width: Dimensions.get('window').width
    }
});
